import { type ProductKeys, productsSupportingEmptyQuery } from '../../constants/products';

/**
 * Determines if the search is searchable based on available products, selected product, and search query.
 */
export const isSearchable = (
	availableProducts: ProductKeys[],
	selectedProduct?: ProductKeys,
	searchQuery: string = '',
): boolean => {
	const isSearchReady = availableProducts && availableProducts.length > 0;
	const isEmptyQuerySearchable = selectedProduct
		? productsSupportingEmptyQuery.includes(selectedProduct)
		: false;
	const isEmptyQuery = !searchQuery || searchQuery.trim() === '';
	const isSearchable = (isEmptyQuery && isEmptyQuerySearchable) || !isEmptyQuery;
	return isSearchReady && isSearchable;
};
